import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import profile from "../Assets/profile.png";

const testimonials = [
  {
    name: "Vaseem Akram",
    role: "BNI Feathers, Virtual Alliance Studios",
    image: profile,
    quote: "We needed 110 T-shirts for an event, and our original vendor backed out last minute. With just three days left, we were referred to Mr. Sankar from BNI Bravo and he truly came through. Despite the tight deadline, he delivered on time, maintained great quality and offered an affordable price. If you're on the lookout for reliable and quality apparels, you're definitely in the right place.",
  },
  {
    name: "Vaseem Akram",
    role: "BNI Feathers, Virtual Alliance Studios",
    image: profile,
    quote: "We needed 110 T-shirts for an event, and our original vendor backed out last minute. With just three days left, we were referred to Mr. Sankar from BNI Bravo and he truly came through. Despite the tight deadline, he delivered on time, maintained great quality and offered an affordable price. If you're on the lookout for reliable and quality apparels, you're definitely in the right place.",
  },
  {
    name: "Vaseem Akram",
    role: "BNI Feathers, Virtual Alliance Studios",
    image: profile,
    quote: "We needed 110 T-shirts for an event, and our original vendor backed out last minute. With just three days left, we were referred to Mr. Sankar from BNI Bravo and he truly came through. Despite the tight deadline, he delivered on time, maintained great quality and offered an affordable price. If you're on the lookout for reliable and quality apparels, you're definitely in the right place.",
  },
];

const TestimonialCarousel = () => {
  return (
    <section className="py-16 px-4">
      <div className="max-w-7xl mx-auto text-center">
        <h2 className="text-3xl font-bold mb-8 text-black">What People Say</h2>
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          navigation
          pagination={{ clickable: true }}
          autoplay={{ delay: 3000 }}
          loop={true}
          className="w-full"
          breakpoints={{
            // For small screens
            320: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            640: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            // Keep medium and large screens unchanged
            768: {
              slidesPerView: 1,
              spaceBetween: 0,
            },
            1024: {
              slidesPerView: 1,
              spaceBetween: 0,
            },
          }}
        >
          {testimonials.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="shadow-lg rounded-xl p-6 sm:p-8 max-w-5xl mx-auto bg-[#311C0E]">
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-12 h-12 sm:w-16 sm:h-16 rounded-full mx-auto mb-3 sm:mb-4 object-cover"
                />
                <p className="text-sm sm:text-lg italic text-gray-700 dark:text-gray-300 mb-3 sm:mb-4">
                  “{item.quote}”
                </p>
                <h4 className="font-semibold text-gray-900 dark:text-white">{item.name}</h4>
                <span className="text-xs sm:text-sm text-gray-500 dark:text-gray-400">{item.role}</span>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default TestimonialCarousel;
